/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BasicPopulationDataModelApiModel } from '../../models/basic-population-data-model-api-model';
import { GetByStateIdsAndCountiesOptsApiModel } from '../../models/get-by-state-ids-and-counties-opts-api-model';

export interface MultiStateCountyPopulation$Params {
      body: GetByStateIdsAndCountiesOptsApiModel
}

export function multiStateCountyPopulation(http: HttpClient, rootUrl: string, params: MultiStateCountyPopulation$Params, context?: HttpContext): Observable<StrictHttpResponse<BasicPopulationDataModelApiModel>> {
  const rb = new RequestBuilder(rootUrl, multiStateCountyPopulation.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BasicPopulationDataModelApiModel>;
    })
  );
}

multiStateCountyPopulation.PATH = '/v1/counties/multi-state-population';
